/**
 * Known feature-flag keys used by runtime-controls.
 */
export const RuntimeControlFeatures = {
  AmplitudeConfig: 'amplitude-config',
};

/**
 * Union type for supported runtime-control flag names.
 */
export type RuntimeControlFeatures =
  (typeof RuntimeControlFeatures)[keyof typeof RuntimeControlFeatures];
